module.exports = __webpack_public_path__ + "img/1490121917.cd055c27.jpg";